import 'normalize.css'
import '@/styles/app.scss'
// import 'core-js/shim'
import 'intersection-observer'

import axios from 'axios'
import device from 'current-device'
import DetectInApp from 'detect-inapp'

import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import App from '@/App'
import router from '@/router'
import ga from '@/scripts/ga'

import SvgSymbol from '@/components/SvgSymbol'
import inviewDirective from '@/directives/inview'
import numericFilter from '@/filters/numeric'
import percentageFilter from '@/filters/percentage'
import signFilter from '@/filters/sign'
import unsignFilter from '@/filters/unsign'

Vue.config.productionTip = false

Vue.use(VueScrollTo)

Vue.device = Vue.prototype.$device = device
Vue.inApp = Vue.prototype.$inApp = new DetectInApp(window.navigator.userAgent)
Vue.http = Vue.prototype.$http = axios
Vue.ga = Vue.prototype.$ga = ga
Vue.bus = Vue.prototype.$bus = new Vue()

Vue.component('SvgSymbol', SvgSymbol)
Vue.directive('inview', inviewDirective)
Vue.filter('numeric', numericFilter)
Vue.filter('percentage', percentageFilter)
Vue.filter('sign', signFilter)
Vue.filter('unsign', unsignFilter)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
